




































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import Apis from '@/Apis/_'
import TipoTabelaProcedimentoEnum from '@/types/enum/TipoTabelaProcedimentoEnum'

interface ProcedimentoOption {
  id: string,
  descricao: string,
}

@Component
export default class ComponentFiltroProcedimentoPrincipal extends Vue {
  @Prop({ default: () => [] }) procedimentoPrincipalTipoTabela: TipoTabelaProcedimentoEnum[]

  @Prop({ default: () => [] }) procedimentoPrincipalIds: string[]

  @Prop({ default: null }) hospitalId: string | null

  @Prop({ default: 0 }) quantidadeHospitaisSelecionados: number

  @Prop({ default: true }) mostrarProcedimento: boolean

  searchText: string = ''
  loadingProcedimentos: boolean = false
  resultadosBusca: ProcedimentoOption[] = []
  procedimentosVistos: ProcedimentoOption[] = []
  maxChipsVisiveis: number = 3

  tiposTabela = [
    { value: TipoTabelaProcedimentoEnum.Tuss, text: 'TUSS' },
    { value: TipoTabelaProcedimentoEnum.Sigtap, text: 'SIGTAP' },
    { value: TipoTabelaProcedimentoEnum.SigtapAmbulatorial, text: 'SIGTAP Ambulatorial' },
  ]

  get tipoProcedimentoSelecionado(): TipoTabelaProcedimentoEnum | null {
    return this.procedimentoPrincipalTipoTabela.length > 0 ? this.procedimentoPrincipalTipoTabela[0] : null
  }

  set tipoProcedimentoSelecionado(value: TipoTabelaProcedimentoEnum | null) {
    this.$emit('update:procedimentoPrincipalTipoTabela', value ? [value] : [])
  }

  get multiplosHospitaisSelecionados() {
    return this.quantidadeHospitaisSelecionados > 1
  }

  get procedimentoDesabilitado() {
    return !this.hospitalId || this.multiplosHospitaisSelecionados
  }

  get hintProcedimento() {
    if (this.multiplosHospitaisSelecionados) return 'Selecione apenas um hospital para filtrar por procedimento'
    if (!this.hospitalId) return 'Selecione um hospital'

    return ''
  }

  get itensProcedimento() {
    const idsNoResultadoDaBusca = new Set(this.resultadosBusca.map(procedimento => procedimento.id))
    const selecionadosForaDaBusca = this.procedimentosVistos.filter(
      procedimento => this.procedimentoPrincipalIds.includes(procedimento.id) && !idsNoResultadoDaBusca.has(procedimento.id),
    )

    return [...this.resultadosBusca, ...selecionadosForaDaBusca]
  }

  get procedimentosOcultos() {
    return this.procedimentoPrincipalIds
      .slice(this.maxChipsVisiveis)
      .map(id => this.procedimentosVistos.find(procedimento => procedimento.id === id))
      .filter((procedimento): procedimento is ProcedimentoOption => !!procedimento)
  }

  removerProcedimento(id: string) {
    this.$emit('update:procedimentoPrincipalIds', this.procedimentoPrincipalIds.filter(procedimentoId => procedimentoId !== id))
  }

  async buscarProcedimentos() {
    if (!this.hospitalId || this.multiplosHospitaisSelecionados) return

    this.loadingProcedimentos = true

    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getProcedimentoPagedSearch({
      hospitalId: this.hospitalId,
      searchText: this.searchText,
      page: 1,
      total: 50,
      tipoProcedimento: this.procedimentoPrincipalTipoTabela[0],
    })

    if (response.success) {
      this.resultadosBusca = response.data.procedimentos as ProcedimentoOption[]

      const idsJaVistos = new Set(this.procedimentosVistos.map(procedimento => procedimento.id))
      const procedimentosNovos = this.resultadosBusca.filter(procedimento => !idsJaVistos.has(procedimento.id))
      this.procedimentosVistos = [...this.procedimentosVistos, ...procedimentosNovos]
    }

    this.loadingProcedimentos = false
  }

  buscarProcedimentosDebounced = _.debounce(() => this.buscarProcedimentos(), 500)

  @Watch('searchText')
  onChangeSearchText() {
    this.buscarProcedimentosDebounced()
  }

  @Watch('procedimentoPrincipalTipoTabela')
  onChangeProcedimentoPrincipalTipoTabela() {
    this.$emit('update:procedimentoPrincipalIds', [])
    this.resultadosBusca = []
    this.procedimentosVistos = []
    this.searchText = ''

    this.buscarProcedimentos()
  }

  @Watch('multiplosHospitaisSelecionados')
  onChangeMultiplosHospitaisSelecionados(value: boolean) {
    if (!value) return

    this.$emit('update:procedimentoPrincipalIds', [])
    this.resultadosBusca = []
    this.procedimentosVistos = []
    this.searchText = ''
  }

  @Watch('hospitalId')
  onChangeHospitalId(value: string | null, valorAnterior: string | null) {
    if (value !== valorAnterior) {
      this.resultadosBusca = []
      this.procedimentosVistos = []
      this.searchText = ''
    }

    if (value) this.buscarProcedimentos()
  }

  mounted() {
    if (this.hospitalId) this.buscarProcedimentos()
  }
}
